<template>
  <div class="flex w-full items-center justify-center gap-4 rounded bg-muted/60 px-4 py-2 text-sm">
    <Flag class="size-4" />
    <span>{{ selectedProgramRef?.name }}</span>
  </div>
</template>

<script setup lang="ts">
import { Flag } from 'lucide-vue-next'
import { computed } from 'vue'

import useProgram from '@/features/programs/hooks/use-program.hook'

const props = defineProps<{
  programId: string | null
}>()

const programIdRef = computed(() => props.programId)
const { programRef: selectedProgramRef } = useProgram(programIdRef)
</script>
